import { Collapse, Box, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import SpeedIcon from '@material-ui/icons/Speed';
import VisibilityIcon from '@material-ui/icons/Visibility';
import clsx from 'clsx';
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';


const useStyles = makeStyles(theme => ({
	nested: {
		paddingLeft: theme.spacing(3),
		"@media (max-width: 700px)": {
			position: "relative",
			left: "-32px",
			width: 'calc(100% + 32px)',
			paddingLeft: theme.spacing(4),
		},
	},
	selected: {
		'&.MuiListItem-root.Mui-selected': {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.common.white,
		},
		'&.MuiListItem-root.Mui-selected p': {
			color: theme.palette.common.white,
		},
	},
	nodeHeader: {
		display: 'flex',
		'& span': {
			fontSize: "larger",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
		},
		'& p': {
			marginLeft: '5px',
			fontSize: "larger"
		},
		"@media (max-width: 700px)": {
			flexDirection: " column",
			'& span': {
				marginLeft: '5px',
				fontSize: "small",
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap",
			},
			'& p': {
				marginLeft: '5px',
				fontSize: "small",
			},
		},
	},
	iconButton: {
		"@media (max-width: 700px)": {
			position: "relative",
			left: "-36px",
		}
	},
	empresa: {
		"@media (max-width: 700px)": {
			// backgroundColor: theme.palette.primary.main,
			height: "50px",
			padding: "10px",
			marginBottom: "1px",
			// color: "#e0e0e0"
		},
	},
	zona: {
		"@media (max-width: 700px)": {
			// background: "#c1c1c1",
			marginLeft: theme.spacing(1),
			height: "50px",
			padding: "10px",
			marginBottom: "1px"
		}
	},
	localizacion: {
		"@media (max-width: 700px)": {
			// background: "#e0e0e0",
			marginLeft: theme.spacing(2),
			height: "50px",
			padding: "10px",
			marginBottom: "1px"
		}
	},
	sublocaclizacion: {
		"@media (max-width: 700px)": {
			// background: "#f1efef",
			marginLeft: theme.spacing(3),
			height: "50px",
			padding: "10px",
			marginBottom: "1px"
		}
	},
	visibilityIcon: {
		marginRight: theme.spacing(1),
		"@media (max-width: 700px)": {
			color: "#343538"
		}
	},
	wordCut: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap"
	},
	meterWithoutChild: {
		marginRight: 24,
		"@media (max-width: 700px)": {
			marginRight: 0
		},
		"@media (max-width: 400px)": {
			// display: "none"
		},
	},
	iconMedidor: {
		"@media (max-width: 700px)": {
			marginRight: theme.spacing(6)
		}
	}
}));


export default function BillFilterNode({ node, selectedNode, handleSelectedNode, statusNodes }) {
	const classes = useStyles();
	const [open, setOpen] = useState(true);
	const [statusNode, setStatusNode] = useState(true);

	//Verifica status de el medidor.
	useEffect(() => {
		if (!node?.virtual) {
			let nodeId = node?.id
			let nodeAux = statusNodes?.find(e => e.node_id === nodeId)
			setStatusNode(nodeAux?.online)
		}
	}, [statusNodes, node])

	//Identifico vista mobile o desktop para q la tabla muestre solo total.
	useEffect(() => {
		if (node.level_nombre === 'localización') {
			setOpen(false)
		}
	}, [node.level_nombre])

	const handleArrows = () => {
		setOpen(!open);
	};

	const iconContractColor = (node) => {
		if (node?.valid_contract === true) return "#52b952"
		return "#454543a6"
	}

	const classNodeSelect = (node) => {
		if (node.level_nombre === "empresa") {
			return classes.empresa
		}
		else if (node.level_nombre === "zona") {
			return classes.zona
		}
		else if (node.level_nombre === "localización") {
			return classes.localizacion
		}
		else if (node.level_nombre === "sublocalización") {
			return classes.sublocaclizacion
		}
		else {
			return ""
		}
	}

	return (
		<>
			<ListItem
				button
				selected={selectedNode ? selectedNode.id === node.id : false}
				className={clsx(classes.selected, classNodeSelect(node))}
				onClick={() => handleSelectedNode(node?.id)}
				// disabled={node.level_nombre !== 'localización' || !node.owner}			
				disabled={!node.has_contract}
			>
				{!node.owner && (
					<Tooltip title={`El nodo ${node.nombre} es compartido`}
					>
						<IconButton edge='end' aria-label='nodo compartido' size='small' color="primary">
							<VisibilityIcon className={classes.visibilityIcon} />
						</IconButton>

					</Tooltip>
				)}

				{/* Barra del color del nodo */}
				{/* <Box bgcolor={node.color} p={0.25} m={0.5} width={8} height={3} marginRight={1}></Box> */}

				<ListItemText primary={node.nombre} secondary={`(${node.level_nombre})`} className={clsx(classes.nodeHeader,)}

				/>
				{/* ICON CONTRACT */}
				<Box width={30} >
					{node.level_nombre === 'localización' && node.has_contract &&
						<Tooltip
							title={node?.valid_contract !== true
								?
								`El nodo  tiene contrato vencido`
								:
								`El nodo si tiene contrato valido al dia de hoy`
							}>
							<IconButton	>
								<RequestPageOutlinedIcon style={{ color: iconContractColor(node) }} />
							</IconButton>
						</Tooltip>
					}
				</Box>

				{/* ICON MEDIDOR FISICO */}
				<Box width={30}
					className={clsx(classes.iconMedidor)}>
					{node.medidor &&
						<Tooltip title={`${node.nombre} tiene un medidor asociado`}>
							<IconButton	>
								<SpeedIcon style={statusNode ? { color: '#66bb6a' } : { color: '#ef5350' }} />
							</IconButton>
						</Tooltip>
					}
				</Box>


				{/* ICON OPEN CLOSE */}
				<ListItemSecondaryAction >
					<Box width={30}>
						{node.hijos && node.level_nombre !== "localización" &&
							node.hijos.length > 0 &&
							(open ? (
								<IconButton edge='end' aria-label='contraer' onClick={handleArrows}>
									<ExpandLess />
								</IconButton>

							) : (

								<IconButton edge='end' aria-label='expandir' onClick={handleArrows}>
									<ExpandMore />
								</IconButton>
							))}
					</Box>
				</ListItemSecondaryAction>

			</ListItem>
			{node.hijos ? (
				<Collapse in={open} timeout='auto' unmountOnExit className={classes.nested}>
					<List dense component='div' disablePadding>
						{node.hijos.map(c => (
							<BillFilterNode node={c} key={c.id} handleSelectedNode={handleSelectedNode} selectedNode={selectedNode} statusNodes={statusNodes} />
						))}
					</List>
				</Collapse>
			) : null}
		</>
	);
}
